import { ArrowDown, ArrowUp, theme } from '@dtx-company/shared-components/src'
import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { DrawerFAQsListProps } from './DrawerFAQsList.types'
import { FC, Fragment, useCallback, useState } from 'react'
import { Icon } from '@dtx-company/shared-components/src/components/atoms/Icon/index'
import { ReactPlayer } from '../../../../../../components/ReactPlayer/ReactPlayer'
import { Spacer } from '@dtx-company/shared-components/src/components/atoms/Spacer/index'
import { Text } from '@dtx-company/shared-components/src/components/atoms/Text/index'
import { TextLink } from '@dtx-company/inter-app/src/utils/links'
import { launch } from '../../../assets'
import styled from 'styled-components'

const VideoContainer = styled(Box)`
  iframe {
    border-radius: 20px;
    background: rgba(0, 0, 0, 0.8);
  }
`

export const DrawerFAQsList: FC<DrawerFAQsListProps> = ({ faqs, title }) => {
  const [openSectionLink, setOpenSectionLink] = useState('')

  const toggleSection = useCallback(
    (link: string): void => {
      const isOpen = openSectionLink === link
      if (isOpen) return setOpenSectionLink('')
      setOpenSectionLink(link)
    },
    [openSectionLink]
  )
  return (
    <>
      <Box mx={'24px'} justifyContent={'space-between'}>
        <Text variant={'header/page'} data-testid="drawer-title">
          {title}
        </Text>
      </Box>
      <Spacer my={'8px'} />
      {faqs.map(item => {
        const link = item.link
        const isSectionOpen = openSectionLink === link
        return (
          <Fragment key={link}>
            <Box
              tabIndex={0}
              cursor="pointer"
              justifyContent={'space-between'}
              py={'12px'}
              borderTop={`1px solid ${theme.colors.secondary.border}`}
              onClick={() => toggleSection(link)}
            >
              <Box mx={'24px'} justifyContent={'space-between'} width={'100%'}>
                <Text variant={'chart/title'}>{item.title}</Text>
                <Box mx="24px">
                  {isSectionOpen ? (
                    <ArrowUp color={theme.colors.primary.flowBlue} />
                  ) : (
                    <ArrowDown color={theme.colors.primary.flowBlue} />
                  )}
                </Box>
              </Box>
            </Box>
            <Box
              mx={'24px'}
              height={'max-content'}
              collapsible={{
                open: isSectionOpen,
                maxHeight: item.video ? 290 : 56
              }}
            >
              <Spacer my={'16px'} />
              {item.video ? (
                <VideoContainer data-testid={`faq-video-player-${item.title}`}>
                  <ReactPlayer
                    url={item.link}
                    width="100%"
                    config={{
                      vimeo: {
                        playerOptions: {
                          controls: true,
                          playsInline: true,
                          responsive: true
                        }
                      }
                    }}
                  />
                </VideoContainer>
              ) : (
                <Box>
                  <TextLink
                    tabIndex={0}
                    variant={'accordion/secondary'}
                    href={item.link}
                    isExternal
                    color={theme.colors.primary.flowBlue}
                    data-testid={`link-${item.title}`}
                  >
                    Article: {item.title} <Icon src={launch} verticalAlign="middle" />
                  </TextLink>
                </Box>
              )}
              <Spacer my={'24px'} />
            </Box>
          </Fragment>
        )
      })}
    </>
  )
}
